import { SETTINGS_TRUE_VALUE } from '@spike/marketplace-model';

type SettingLike = { key: string; value: string };

// The API can return the same setting key more than once (e.g. 'f' and then 't'),
// so a setting is enabled when any of its rows is true.
export const isSettingEnabled = (settings: Array<SettingLike> | undefined | null, key: string): boolean =>
    (settings ?? []).some(s => s.key === key && s.value === SETTINGS_TRUE_VALUE);
